const history = {
    state: {
        hasPath: false,
        path: "",
        query: {}
    },
    getters: {
        getHistory(state) {
            return state;
        }
    },
    mutations: {
        PUSH_PATH: (state, router) => {
            state.path = router.path;
            state.query = router.query;
            state.hasPath = true;
        },
        RESET_PATH: (state) => {
            state.path = '';
            state.query = {};
            state.hasPath = false;
        }
    },
}
export default history


// WEBPACK FOOTER //
// ./src/store/modules/history.js